/**
 * 全局状态更新store
 * 使用指南：
 * 此轮询因为涉及到问答，所以一直会轮询，当需要执行其他轮询时，
 * 使用setInfos插入轮询的类型，并设置相应的入参，即可调起轮询
 */
import {makeObservable, observable, action, flow} from 'mobx';
import _ from 'lodash';
import {message} from 'antd';
import {getFollowStyleList} from '../services';

export class ScriptToolStore {
    styleList = [];
    constructor() {
        makeObservable(this, {
            styleList: observable
        });
    }
    getStyleList = async () => {
        const {errno, errmsg, data} = await getFollowStyleList();
        if (errno === 0) {
            this.styleList = data.list;
        }
        else {
            message.error(errmsg);
        }
    };
}

